import { useEffect, useState, useSyncExternalStore } from "react";
import type { SyncClient, SyncState } from "./sync";

export function useSyncState(sync: SyncClient, name: string): SyncState {
  return useSyncExternalStore(
    (fn) => sync.subscribe(fn),
    () => sync.state(name),
  );
}

export function useOnline(): boolean {
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
    };
  }, []);
  return online;
}
